<i18n src="@/common/i18n/i18n-locales.json"></i18n>

<template>
  <f7-page>
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-if-ios="f7:menu" icon-if-md="material:menu" panel-open="left" />
      </f7-nav-left>
      <f7-nav-title>收銀機狀態</f7-nav-title>
    </f7-navbar>
    <f7-list media-list>
      <f7-list-item title="收銀機列表" group-title />
      <f7-list-item
        v-for="(cashier, index) in cashiers"
        :key="`cashier-${index}`"
        :title="cashier.name"
        :text="`ID: ${cashier.id}`"
        :after="$t(`printerPaperAmountStatusType.${cashier.printerPaperAmount}`)" />
    </f7-list>
  </f7-page>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  async created () {
    await this.getCasheriers()
  },
  computed: {
    ...mapState('cashierModule', ['cashiers'])
  },
  methods: {
    ...mapActions('cashierModule', ['getCasheriers'])
  }
}
</script>
